import React from "react"
import { withRouter } from "react-router-dom"
import { Card, CardBody, Container, Row, Col } from "reactstrap"

import IndexNavbar from "components/Navbars/IndexNavbar.js"
import Footer from "components/Footers/Footer.js"

class ThankYou extends React.Component {
  state = {
    orderData: null,
  }

  componentDidMount() {
    this._setOrderDataState()
    // console.log(this.props.location.state);
  }

  _setOrderDataState() {
    if (
      this.props &&
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.orderData
    ) {
      this.setState({
        orderData: this.props.location.state.orderData,
      })
    }
  }

  render() {
    const { orderData } = this.state
    // if (orderData) {
    //     console.log(JSON.stringify(orderData, null, 4));
    // }
    return (
      <>
        <div className="bg-chift hero-chift">
          <IndexNavbar />
          <div className="main-content">
            <Container>
              <br />
              <br />
              <Row className="justify-content-center">
                <Col lg="7" md="7">
                  <Card className="bg-secondary border-0 mb-0">
                    <CardBody className="px-lg-5 py-lg-5">
                      {orderData ? (
                        <div className="mb-4">
                          <h3>
                            Your <b>{orderData.packageTitle} Package</b> Has
                            Been Booked!
                          </h3>
                          <h3>Order Details:</h3>
                          <div className="ml-4">
                            <p className="mb-0">
                              {orderData.package.title} Package
                            </p>
                            <p className="mb-0">{`$${orderData.finalCost}`}</p>
                            <p className="mb-0">{`${
                              orderData.orderTime
                            } on ${orderData.orderDate.toDateString()}`}</p>
                            <p className="mb-0">{orderData.orderId}</p>
                            <p>{orderData.merchantPhone}</p>
                          </div>
                          <h3>Thank You For Using Faver!</h3>
                          <hr />
                          <h3>
                            Your feedback is valuable to us. Please email Faver
                            at support@needafaver.com with any questions or
                            comments.
                          </h3>
                        </div>
                      ) : (
                        <div className="text-center mb-4">
                          <h3>Thank You For Using Faver!</h3>
                        </div>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
          <Footer transparent />
        </div>
      </>
    )
  }
}

export default withRouter(ThankYou)
